var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4a8.5 8.5 0 110 17 8.5 8.5 0 010-17zm2.808 4.85H9.692a.842.842 0 00-.842.842v5.616c0 .465.377.842.842.842h5.616a.842.842 0 00.842-.842V9.692a.842.842 0 00-.842-.842zm-4.98 3.088a2.246 2.246 0 104.419.562c0-.194-.028-.382-.075-.562h.636v3.09a.28.28 0 01-.28.28H9.972a.28.28 0 01-.281-.28v-3.09zm2.172-.842a1.404 1.404 0 110 2.808 1.404 1.404 0 010-2.808zm2.527-1.404a.28.28 0 01.281.28v.843a.28.28 0 01-.28.281h-.843a.28.28 0 01-.28-.281v-.842a.28.28 0 01.28-.28z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
export default SvgInstagram;